import { Instant as BaseInstant }	from "ts-base/time/instant";

import { Numeric }	from "@v3/data/numeric";

// whole number of millliseconds since the unix epoch
export type Instant		= Numeric.Value<typeof Instant>;
export const Instant	= Numeric.fromBase(BaseInstant, "must be a unix time in milliseconds");
